import { FlexGrid, Panel } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import EmergencyStatusReport from '../../prop-types/emergency-status-report';
import OutageStatusIcons from '../OutageStatusBadges';
import styles from './OutageStatus.module.css';

const cx = classnames.bind(styles);

export default function OutageStatus({
  powerReport,
  gasReport,
  dieselReport,
  sellsDiesel,
}) {
  const { t } = useTranslation(['station', 'miscellaneous']);
  const message = sellsDiesel
    ? t('outage.stationInAffectedAreaWithDiesel', { ns: 'station' })
    : t('outage.stationInAffectedArea', { ns: 'station' });

  return (
    <FlexGrid container>
      <FlexGrid.Column desktop={8}>
        <Panel className={cx('warningPanel')} color="orange">
          <img
            className={cx('warningIcon')}
            src="//static.gasbuddy.com/web/icons/warning-white.svg"
            alt={t('icons.warning', { ns: 'miscellaneous' })}
          />
          <p className={cx('message')}>{message}</p>
          <img
            className={cx('warningIcon')}
            src="//static.gasbuddy.com/web/icons/warning-white.svg"
            alt={t('icons.warning', { ns: 'miscellaneous' })}
          />
        </Panel>
      </FlexGrid.Column>
      <FlexGrid.Column className={cx('iconContainer')} desktop={4}>
        <OutageStatusIcons
          powerReport={powerReport}
          gasReport={gasReport}
          dieselReport={dieselReport}
          sellsDiesel={sellsDiesel}
        />
      </FlexGrid.Column>
    </FlexGrid>
  );
}

OutageStatus.propTypes = {
  powerReport: EmergencyStatusReport,
  gasReport: EmergencyStatusReport,
  dieselReport: EmergencyStatusReport,
  sellsDiesel: PropTypes.bool,
};

OutageStatus.defaultProps = {
  powerReport: {
    status: true,
  },
  gasReport: {
    status: true,
  },
  dieselReport: undefined,
  sellsDiesel: false,
};
